import { useAddProductToCartMutation } from 'graphql/generated/remote-schema-hasura';
import StorageService from 'utilities/storageService';
import { LOCAL_STORAGE_SHOP_SELECTED_PROVIDER } from 'utilities/constants';
import { useNavigate } from 'react-router-dom';
import { SHOP_CHECKOUT_LINK } from 'utilities/routes';
import { useAuth } from 'auth/context/AuthContext';
import { useMemo } from 'react';
import { Roles } from '../../../../../firebase/interfaces';

interface IUseGetRecommendedProductProps {
  providerId: string;
}

const selectedProviderStorage = new StorageService(
  LOCAL_STORAGE_SHOP_SELECTED_PROVIDER,
  localStorage,
  '',
);

export const useGetRecommendedProduct = ({
  providerId,
}: IUseGetRecommendedProductProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isProvider = useMemo(() => user?.role === Roles.PROVIDER, [user]);

  const [addProduct, { loading }] = useAddProductToCartMutation();

  const handleOnPurchase = async (
    productId: number,
    quantity: number,
    recommendationId: string,
  ) => {
    selectedProviderStorage.setData({ value: providerId });
    await addProduct({
      variables: {
        productId: Number(productId),
        quantity: quantity,
        recommendationId,
      },
    });
    navigate(SHOP_CHECKOUT_LINK);
  };

  return {
    handleOnPurchase,
    isProvider,
    loading,
  };
};
